import { render, staticRenderFns } from "./VehiclePageV2.vue?vue&type=template&id=0af603d1&scoped=true&"
import script from "./VehiclePageV2.vue?vue&type=script&lang=js&"
export * from "./VehiclePageV2.vue?vue&type=script&lang=js&"
import style0 from "./VehiclePageV2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VehiclePageV2.vue?vue&type=style&index=1&id=0af603d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af603d1",
  null
  
)

export default component.exports